import { lazyWithSuspense } from '~/utilities/lazyWithSuspense';

export const GroupRecordRecoveryScreen = lazyWithSuspense(
  async () => import('~/singlePageApp/screens/GroupRecordRecoveryScreen/GroupRecordRecovery'),
  {
    loadingState: <div />,
    exportKey: 'GroupRecordRecovery',
  },
);
